<template>
  <div class="container bg_fff">
    <online-pat-info :info="order" :show-control="false"></online-pat-info>
  </div>
</template>

<style scoped lang="scss">

</style>

<script>
import {onlineService} from "../../lib/service/online";
import OnlinePatInfo from "../../components/online/pat-info";

export default {
  name: "Detail",
  data() {
    return {
      order: {}
    }
  },
  components: {OnlinePatInfo},
  created() {
    this.getInfo(this.$route.query.id);
  },
  beforeDestroy() {
  },
  methods: {
    async getInfo(id) {
      this.order = await onlineService.info(id)
    },
  },
}
</script>

